export default __webpack_public_path__ + "static/media/Recover_Valkyrie.b540ef1d.svg";